import React, { useEffect, useRef, useState } from "react";
import { useGeneratorHeaderSaveRegister } from "../../../contexts/generator-header-save.context";
import { useI18next } from "../../../../plugins/gatsby-plugin-ap-i18next/src/useI18next";
import { useFormikContext } from "formik";
import { navigate } from "gatsby";

import Arrow from "../../../assets/images/svg/expand-button.svg";
import {
    applyButton,
    clearButton,
    container,
    filtersBox,
    filtersExpandBox,
    generate,
    generateButton,
    mobileButtons,
    mobileHeader,
    buttonMobileHeader,
    noMobile,
    open,
    openButton,
    pressSpace,
    price,
    priceFilterRow,
    priceList,
    productList,
    saveButton,
    selectList,
    selects,
    leftSide,
    leftSideScroll,
    leftSideCollapsed,
    rightSide,
    rightSideExpanded,
    selectInput,
    titleStyles,
    titleStylesTop,
    titleBig,
    collapseFiltersButton,
    collapseFiltersButtonMenu,
    collapseFiltersHamburger,
    saveButtonFilter,
    generateTip,
    arrowTop,
    surveyPopupContainer,
    surveyInfo,
    surveyButtonMini,
    surveyFillTablet,
    loginButton,
    buttonContainer,
    clickTip,
    generateButtonsBar,
    tryOnButton,
    virtualTryOnContainer,
    virtualTryOnContainerImage,
    productCardMinimal,
    buttonContent,
    mobileButtonsBottom,
    productsViewMobileContainer,
    imageSliderWrapper,
    checkAvailabilityButton,
    checkAvailabilityButtonInner,
    checkAvailabilityText,
    checkAvailabilityIcon,
    uploadPhotoContainer,
    guideHelpRow,
    guideHelpBtn,
    productListTryOnView,
    scrollTopButton,
    scrollTopButtonVisible,
    scrollTopIcon
} from "./generator-draw-fields.module.scss";
import FilterIcon from "../../../assets/images/svg/filters.svg";
import { breakpoints } from "../../../config/breakpoints";
import { fieldsAvailableToClear, priceFilters, selectFiltersConfigs } from "../config";
import {
    EGeneratorFilterKeys,
    IGeneratorFormValues,
    IGeneratorProductsSetPayload,
    TBlockedProduct,
    TGeneratorFilters,
} from "../../../models/generator.model";
import { IProduct } from "../../../models/product.model";
import { capitalizeFirstLetter } from "../../../utils/capitalize-first-letter";
import {
    selectGeneratorProducts,
    selectGeneratorProductsStatus,
} from "../../../redux/generator-products/generator-products.selectors";
import useMediaQuery from "../../../hooks/use-media-query";
import useUser from "../../../apps/auth/hooks/use-user";

import Select from "../../../components/atoms/form/select";
import PriceButtonsFilters from "../molecules/price-buttons-filters";
import ProductCard from "../molecules/product-card";
import Button from "../../../components/atoms/button";
import SwitchInput from "../../../components/atoms/form/switch-input";
import ButtonClose from "../../../components/atoms/button-close";
import ButtonWand from "../../../components/molecules/button-wand";
import ImageSlider from "../../../components/organisms/image-slider";
import { Helmet } from "react-helmet";
import ButtonIcon from "../../../components/molecules/button-icon";
import { useDispatch, useSelector } from "react-redux";
import { createVirtualTryOnAction } from "../../../redux/virtual-tryon/virtual-tryon.actions";
import { IVirtualTryOn } from "../../../models/virtualtryon.model";
import { selectVirtualTryOn } from "../../../redux/virtual-tryon/virtual-tryon.selectors";
import Loader from "../../../components/atoms/loader";
import ImageUploader from "../../../components/molecules/image-uploader";
import { uploadFileToApi } from "../../../services/fileupload-services";
import ImageSliderSimple from "../../../components/organisms/image-slider-simple";
import { postProductStatistic } from '../../../services/product-services';
import { useModalContext } from "../../../contexts/modal.context";
import { EModal } from "../../../models/modal.model";

interface IGeneratorDrawFields {
    className?: string;
    filters: TGeneratorFilters;
    products: IProduct[];
    onSpaceKeydown?(): void;
    onSave?(): void;
    counterClick?: number;
}

const GeneratorDrawFields: React.FC<IGeneratorDrawFields> = ({
    className = "",
    filters,
    products,
    onSpaceKeydown,
    onSave,
    counterClick,
}) => {
    const { t } = useI18next();
    const formik = useFormikContext<IGeneratorFormValues>();
    const isTablet = useMediaQuery(breakpoints.tablet);
    const [isOpen, setIsOpen] = useState(false);
    const [isFiltersCollapsed, setIsFiltersCollapsed] = useState(false);
    const [surveyPopup, setSurveyPopup] = useState(false);
    const [tryOnView, setTryOnView] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isUploadPhotoButton, setIsUploadPhotoButton] = useState(false);
    const [isScrollTopVisible, setIsScrollTopVisible] = useState(false);
    const surveyPopupRef = useRef(surveyPopup);
    const { sessionId, sessionGuid, items }: IGeneratorProductsSetPayload = useSelector(selectGeneratorProducts);
    const virtualTryOnViewer: IVirtualTryOn = useSelector(selectVirtualTryOn);
    const isFirstRender = useRef(true);
    const [uploadFile, setUploadFile] = useState<File | null>(null);
    const [virtalTryOnList, setVirtualTryOnList] = useState<string[]>([]);
    const [customIndex, setCurrentIndex] = useState(0);

    const [loadingVirtualTryOnListTexts] = useState([
        "Czarodziejska przymiarka w 3…2…1…",
        "Magiczna przemiana w toku ✨",
        "Znikają wątpliwości, pojawia się look",
        "Odliczaj do efektu wow",
        "Magia trwa — bądź gotowa",
        "Magiczne zaklęcie już działa…",
        "Właśnie zakładam na Ciebie nowy look",
        "Zaraz zobaczysz, jak nowy outfit lśni na Tobie ✨",
        "Magia działa… ubrania właśnie się zakładają 🪄"
    ]);
    //const [showSpecialTryOn, setShowSpecialTryOn] = useState(false);

    const { data, isLoggedIn } = useUser();
    const dispatch = useDispatch();

    const { addModal } = useModalContext();
    const setHeaderSaveConfig = useGeneratorHeaderSaveRegister();

    useEffect(() => {
        if (isLoggedIn && !tryOnView && !isTablet && typeof onSave === "function") {
            setHeaderSaveConfig({
                visible: true,
                onSave: () => {
                    onSave();
                },
            });
        } else {
            setHeaderSaveConfig(null);
        }
        return () => setHeaderSaveConfig(null);
    }, [isLoggedIn, tryOnView, isTablet, onSave, setHeaderSaveConfig]);

    const handleOpenPhotoGuide = () => {
        addModal({
            key: EModal.PHOTO_GUIDE,
        });
    };


    useEffect(() => {
        surveyPopupRef.current = surveyPopup;
    }, [surveyPopup]);
    const handleOpenFilters = () => {
        setIsOpen(true);
    };

    const handleCloseFilters = () => {
        setIsOpen(false);
    };

    const handleToggleFiltersCollapse = () => {
        setIsFiltersCollapsed((prev) => !prev);
    };

    const handleSave = () => {
        if (typeof onSave !== "function") return;
        onSave();
    };

    const handleClear = () => {
        fieldsAvailableToClear.forEach((fieldKey) => {
            const clearedValue = Array.isArray(formik.values[fieldKey]) ? [] : "";
            formik.setFieldValue(fieldKey, clearedValue);
        });
    };

    const handleLockProduct = (product: IProduct) => () => {
        const lockedProducts = formik.values.blockedProducts;
        const lockedProductIds = lockedProducts.map((product) => product.productId);
        let newLockedProducts: TBlockedProduct[];
        if (lockedProductIds.includes(product.productId)) {
            newLockedProducts = lockedProducts.filter(
                (lockedProduct) => lockedProduct.productId !== product.productId
            );
        } else {
            newLockedProducts = [
                ...lockedProducts,
                { productId: product.productId, categoryGroup: product.categoryGroup },
            ];
        }
        formik.setFieldValue("blockedProducts", newLockedProducts);
    };

    const handleTryOnClick = () => {
        console.log("handleTryOnClick called: ", sessionGuid);
        setIsLoading(true);
        dispatch(
            createVirtualTryOnAction({
                guid: sessionGuid
            })
        );
    }

    const handleTryOnAndUploadClick = async () => {
        console.log("handleTryOnAndUploadClick called: ", sessionGuid);
        setIsLoading(true);

        var uploadResponse = await uploadFileToApi(uploadFile);

        setUploadFile(null);
        setIsUploadPhotoButton(false);
        dispatch(
            createVirtualTryOnAction({
                guid: sessionGuid
            })
        );
    }
    const handleShowProducts = () => {
        console.log("handleShowProducts called: ", sessionGuid);
        setTryOnView(false);
    }

    const onUploadPhoto = (file: File) => {
        console.log("onUploadPhoto called: ", file);
        setUploadFile(file);
        setIsUploadPhotoButton(true);
    }

    const productClickCustom = (product: IProduct) => {
        console.log("productClickCustom called: ", product);
        var index = products.findIndex(p => p.productId === product.productId);
        console.log("productClickCustom called: ", index);
        setCurrentIndex(index);
    }

    const handleCheckAvailability = () => {
        if (products.length > 0 && customIndex !== undefined && products[customIndex]) {
            const product = products[customIndex];
            postProductStatistic(product);
            const url = product.affiliateUrl || product.url;
            if (url) {
                window.open(url, '_blank');
            }
        }
    }

    const handleScrollTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    useEffect(() => {
        if (isTablet) {
            setIsScrollTopVisible(false);
            return;
        }

        const handleScroll = () => {
            setIsScrollTopVisible(window.scrollY > 20);
        };

        handleScroll();
        window.addEventListener("scroll", handleScroll, { passive: true });

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [isTablet]);

    useEffect(() => {
        const handleKeydown = (event: KeyboardEvent) => {
            if (event.code !== "Space") return;
            console.log("surveyPopup (ref):", surveyPopupRef.current);
            if (surveyPopupRef.current) return;
            event.preventDefault();
            if (typeof onSpaceKeydown !== "function") return;
            console.log("Działam!!!");
            onSpaceKeydown();
        };
        document.addEventListener("keydown", handleKeydown);

        if (typeof window !== "undefined" && typeof window.gtag === "function") {
            console.log("Conversion event triggered");
            window.gtag('event', 'conversion', { 'send_to': 'AW-985215664/GkuICPjm3bcaELDl5NUD' });
        }

        return () => {
            document.removeEventListener("keydown", handleKeydown);
        };
    }, []);
    useEffect(() => {
        setTryOnView(false);
    }, [products])

    // useEffect(() => {
    //     setShowSpecialTryOn(data
    //         && (data.userId == 11 || data.userId == 12 || data.userId == 17 || data.userId == 18 || data.userId == 20 || data.userId == 21 || data.userId == 23));
    // }, [data])
    useEffect(() => {
        console.log("!!!!virtualTryOnViewer: ", virtualTryOnViewer)
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return; // NIE wykonuj kodu przy pierwszym renderze
        }
        if (virtualTryOnViewer && virtualTryOnViewer.imageUrl) {
            console.log("virtualTryOnViewer changed: ", virtualTryOnViewer);
            setIsLoading(false);
            setTryOnView(true);
            const list = [virtualTryOnViewer.imageUrl1];
            if (virtualTryOnViewer.imageUrl2) {
                list.push(virtualTryOnViewer.imageUrl2);
            }
            setVirtualTryOnList(list);
        }
    }, [virtualTryOnViewer])
    useEffect(() => {
        console.log(counterClick);
        if (counterClick && !isLoggedIn) {
            setSurveyPopup(counterClick >= 4);
        }
    }, [counterClick]);

    return (
        <>
            {isLoading && <Loader position="fixed" texts={loadingVirtualTryOnListTexts} />}
            <Helmet>
                <script>
                    {`
                  gtag('event', 'conversion', {'send_to': 'AW-985215664/GkuICPjm3bcaELDl5NUD'});
                `}
                </script>
            </Helmet>
            <div style={{ display: "none" }}>!!</div>
            {surveyPopup && <div className={surveyPopupContainer}>
                <h1>Wyczarujmy Twój styl!</h1>
                <p>Teraz chcemy poznać Cię bliżej. Jaka jesteś, co lubisz, jaki masz styl. Te informacje umożliwią nam stworzenie stylizacji dedykowanej właśnie Tobie!</p>
                <p>Jeśli już masz swoje konto kliknij Zaloguj się a przygotujemy dla Ciebie dedykowane stylizacje</p>
                <div className={buttonContainer}>
                    {/* link={'/auth'} */}
                    <Button onClick={(e) => { navigate('/auth') }} className={loginButton}>{"Zaloguj się"}</Button>
                    <ButtonWand text={"Wystylizuj mnie"} link={'/ankieta'}></ButtonWand>
                </div>
            </div>}
            <div className={`${container} ${className}`}>
                <div className={`${leftSide} ${!isTablet && isFiltersCollapsed ? leftSideCollapsed : ""}`}>
                    <div className={leftSideScroll}>
                        <div className={filtersExpandBox}>
                        {isLoggedIn && <>
                            <button type="button" onClick={handleOpenFilters} className={openButton}>
                                <FilterIcon /> {t("generator.button.filters")}
                            </button>
                            <Button
                                color="primary"
                                type="filled"
                                className={`${saveButton} ${saveButtonFilter}`}
                                onClick={handleSave}
                                htmlType="button"
                            >
                                {t("generator.button.save")}
                            </Button>
                        </>}
                        {!isLoggedIn &&
                            <div className={surveyFillTablet}>
                                <p> Chcemy Cię lepiej poznać! Odpowiedz na kilka pytań, a stworzymy stylizację idealnie dla Ciebie.</p>
                                <ButtonWand className={surveyButtonMini} link={'/ankieta'} text={"Wystylizuj mnie"}></ButtonWand>
                            </div>}
                        </div>
                        <div className={`${filtersBox} ${isOpen ? open : ""}`}>
                        <div className={mobileHeader}>
                            <p>{t("generator.filters.title")}</p>
                            <ButtonClose className={buttonMobileHeader} onClick={handleCloseFilters} />
                        </div>
                        <div className={titleStyles}>
                            <div className={titleStylesTop}>
                                <div className={titleBig}>
                                    Stwórz<br />stylówkę
                                </div>
                                {!isTablet && (
                                    <button
                                        type="button"
                                        className={`${collapseFiltersButton} ${
                                            isFiltersCollapsed ? collapseFiltersButtonMenu : ""
                                        }`}
                                        onClick={handleToggleFiltersCollapse}
                                        aria-label={
                                            isFiltersCollapsed
                                                ? "Rozwiń panel filtrów"
                                                : "Zwiń panel filtrów"
                                        }
                                    >
                                        {isFiltersCollapsed ? (
                                            <span
                                                className={collapseFiltersHamburger}
                                                aria-hidden
                                            >
                                                <span />
                                                <span />
                                                <span />
                                            </span>
                                        ) : (
                                            "×"
                                        )}
                                    </button>
                                )}
                            </div>
                            {!isLoggedIn && <div className={surveyInfo}>
                                Chcemy Cię lepiej poznać! Odpowiedz na kilka pytań, a stworzymy stylizację idealnie dla Ciebie.
                            </div>}
                            {!isLoggedIn && <ButtonWand link={'/ankieta'} className={surveyButtonMini} text={"Wystylizuj mnie"}></ButtonWand>}
                        </div>
                        {isLoggedIn && <div className={selects}>
                            {selectFiltersConfigs.map((config) => {
                                const { isMultiselect, selectClassName, filterKey } = config;
                                return (
                                    <Select
                                        key={filterKey}
                                        className={`${selectClassName} ${selectInput}`}
                                        options={filters[filterKey]}
                                        name={filterKey}
                                        label={t(`generator.form.label.${filterKey}`)}
                                        placeholder={t(`generator.form.placeholder.${filterKey}`)}
                                        isMultiselect={isMultiselect}
                                        showCounter={isMultiselect}
                                        colorTheme="light"
                                        styleTheme="compact"
                                        selectText={isMultiselect ? "label" : "option"}
                                        listClassName={selectList}
                                        layout="generatorPanel"
                                        generatorPanelVariant={
                                            filterKey === EGeneratorFilterKeys.colors
                                                ? "colors"
                                                : filterKey === EGeneratorFilterKeys.patterns
                                                ? "patterns"
                                                : "default"
                                        }
                                    />
                                );
                            })}
                            <div className={priceList}>
                                {priceFilters.map((filterKey) => {
                                    return (
                                        <div key={filterKey} className={priceFilterRow}>
                                            <PriceButtonsFilters
                                                name={filterKey}
                                                options={filters[filterKey]}
                                                label={t(`generator.form.label.${filterKey}`)}
                                            />
                                            {/* <SwitchInput
                                                className={price}
                                                name={filterKey}
                                                options={filters[filterKey]}
                                                label={t(`generator.form.label.${filterKey}`)}
                                                showLabel={false}
                                            /> */}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>}
                        <div className={mobileButtons}>
                            <Button
                                color="primary"
                                type="outlined"
                                className={clearButton}
                                htmlType="button"
                                onClick={handleClear}
                            >
                                {t("generator.button.clear")}
                            </Button>
                            <Button
                                color="beige"
                                type="filled"
                                className={applyButton}
                                htmlType="submit"
                                onClick={handleCloseFilters}
                            >
                                {t("generator.button.apply")}
                            </Button>
                        </div>
                        </div>
                    </div>

                </div>
                <div className={`${rightSide} ${!isTablet && isFiltersCollapsed ? rightSideExpanded : ""}`}>
                    {!tryOnView && <>
                        {!isTablet && <div className={productList}
                        style={{ gridTemplateColumns: `repeat(${products.length}, minmax(0, 1fr))` }}
                        >
                            {products.map((product) => {
                                const categoryPriceKey = `price${capitalizeFirstLetter(
                                    product.categoryGroup
                                )}` as keyof TGeneratorFilters;
                                return (
                                    <ProductCard
                                        showInputs={true}
                                        isTablet={isTablet}
                                        key={product.productId}
                                        product={product}
                                        productLength={products.length}
                                        onPadlockClick={handleLockProduct(product)}
                                        isLocked={getIsLocked(formik.values.blockedProducts, product)}
                                        classNameProduct={price}
                                        nameProduct={categoryPriceKey}
                                        optionsProduct={filters[categoryPriceKey]}
                                        labelProduct={t(`generator.form.label.${categoryPriceKey}`)}
                                    />
                                );
                            })}
                        </div>}
                        {isTablet && <div className={productsViewMobileContainer}>
                            <div className={imageSliderWrapper}>
                                <ImageSlider products={products} customIndex={customIndex} onSlideUp={onSpaceKeydown} surveyPopup={surveyPopup} isLoggedIn={isLoggedIn} />
                                {!tryOnView && (
                                    <div className={checkAvailabilityButton}>
                                        <button type="button" onClick={handleCheckAvailability} className={checkAvailabilityButtonInner}>
                                            <div className={checkAvailabilityText}>
                                                <span>Sprawdź</span>
                                                <span>dostępność</span>
                                            </div>
                                            <svg className={checkAvailabilityIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="10" cy="10" r="7" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                                <path d="m16 16 4 4" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </button>
                                    </div>
                                )}
                            </div>
                            <div className={productList}>
                                {products.map((product) => {
                                    const categoryPriceKey = `price${capitalizeFirstLetter(
                                        product.categoryGroup
                                    )}` as keyof TGeneratorFilters;
                                    return (
                                        <ProductCard
                                            isMinimal={true}
                                            className={productCardMinimal}
                                            classNameButtonContent={buttonContent}
                                            showInputs={false}
                                            isTablet={isTablet}
                                            key={product.productId}
                                            product={product}
                                            productLength={products.length}
                                            classNameProduct={price}
                                            nameProduct={categoryPriceKey}
                                            optionsProduct={filters[categoryPriceKey]}
                                            productClickCustomFn={productClickCustom}
                                            labelProduct={t(`generator.form.label.${categoryPriceKey}`)}
                                        />
                                    );
                                })}
                            </div>
                        </div>}
                    </>}
                    {tryOnView && <div className={virtualTryOnContainer}>
                        {virtualTryOnViewer && virtualTryOnViewer.status == 0 && <>
                            {!isTablet && <h2>Stylówka na Tobie</h2>}
                            <div className={virtualTryOnContainerImage}>
                                {!isTablet && virtualTryOnViewer && virtualTryOnViewer.imageUrl && <img src={virtualTryOnViewer.imageUrl}></img>}
                                {isTablet && virtualTryOnViewer && virtualTryOnViewer.imageUrl && <div style={{ flex: '85%' }}><ImageSliderSimple products={virtalTryOnList} onSlideUp={onSpaceKeydown} surveyPopup={surveyPopup} isLoggedIn={isLoggedIn} /></div>}
                                <div className={`${productList} ${productListTryOnView}`}>
                                    {products.map((product) => {
                                        const categoryPriceKey = `price${capitalizeFirstLetter(
                                            product.categoryGroup
                                        )}` as keyof TGeneratorFilters;
                                        return (
                                            <ProductCard
                                                isMinimal={true}
                                                className={productCardMinimal}
                                                classNameButtonContent={buttonContent}
                                                showInputs={false}
                                                isTablet={isTablet}
                                                key={product.productId}
                                                product={product}
                                                productLength={products.length}
                                                classNameProduct={price}
                                                nameProduct={categoryPriceKey}
                                                optionsProduct={filters[categoryPriceKey]}
                                                labelProduct={t(`generator.form.label.${categoryPriceKey}`)}
                                            />
                                        );
                                    })}
                                </div>
                            </div>
                        </>}
                        {virtualTryOnViewer && virtualTryOnViewer.status == -1 && <>
                            <div className={uploadPhotoContainer}>
                                <ImageUploader onUploadPhoto={onUploadPhoto} isSpecial={true}></ImageUploader>
                            </div>

                            <div className={guideHelpRow}>
                                <button className={guideHelpBtn} type="button" onClick={handleOpenPhotoGuide}>
                                    <span className="qmark">?</span>
                                    Jak właściwie wybrać zdjęcie?
                                </button>
                            </div>
                        </>}
                    </div>}
                    <div className={generate}>
                        {/* {isTablet && !tryOnView && <div className={clickTip}><p>Kliknij w obrazek aby obejrzeć ubranie</p></div>} */}
                        {!tryOnView && <div className={generateTip}>
                            <Arrow className={arrowTop} />
                            <p>Przesuń palcem w góre aby wyczarować dalej...</p>
                        </div>}
                        {!surveyPopup &&
                            <div className={generateButtonsBar}>
                                <ButtonWand withLink={false} htmlType="submit" className={generateButton} text={(isTablet ? "Wyczaruj" : t("generator.button.generate"))}>
                                </ButtonWand>
                                {<>
                                    {isLoggedIn && !tryOnView && <ButtonIcon withLink={false} onClick={handleTryOnClick} htmlType="button" className={tryOnButton} text={"Ubierz mnie!"}>
                                    </ButtonIcon>}
                                    {/* {isLoggedIn && tryOnView && !isUploadPhotoButton && <ButtonIcon withLink={false} onClick={handleShowProducts} htmlType="button" className={tryOnButton} text={"Pokaż ubrania"}>
                                    </ButtonIcon>} */}
                                    {isLoggedIn && tryOnView && isUploadPhotoButton && <ButtonIcon withLink={false} onClick={handleTryOnAndUploadClick} htmlType="button" className={tryOnButton} text={"Ubierz mnie!"}>
                                    </ButtonIcon>}
                                </>}
                            </div>
                        }
                        {/* <p className={pressSpace}>{t("generator.press.space")}</p> */}
                    </div>
                    {!isTablet && (
                        <button
                            type="button"
                            className={`${scrollTopButton} ${isScrollTopVisible ? scrollTopButtonVisible : ""}`}
                            onClick={handleScrollTop}
                            aria-label="Przewiń do góry"
                        >
                            <span className={scrollTopIcon} aria-hidden>
                                ↑
                            </span>
                        </button>
                    )}
                </div>
            </div>
        </>
    );
};

function getIsLocked(blockedProducts: TBlockedProduct[], product: IProduct) {
    return blockedProducts.map((product) => product.productId).includes(product.productId);
}

export default GeneratorDrawFields;
